import React from "react";
import { useSelector } from "react-redux";
import CountrySelector from "../CountrySelector";
import { useTranslation } from "../../contexts/LanguageContext";

export default function AppUsers() {
  const { users, loading } = useSelector((state) => state.dashboard);
  const { t } = useTranslation();

  const userStats = [
    { label: t("dashboard.totalUsers"), value: users.totalUsers, color: "bg-blue-500" },
    { label: t("dashboard.stats.verifiedUsers"), value: users.totalVerified, color: "bg-green-500" },
    { label: t("dashboard.companyUsers"), value: users.totalCompanyUsers, color: "bg-purple-500" },
    { label: t("dashboard.personalUsers"), value: users.totalPersonalUsers, color: "bg-orange-500" },
    { label: t("dashboard.androidUsers"), value: users.totalDeviceUsers?.Android || 0, color: "bg-green-600" },
    { label: t("dashboard.iosUsers"), value: users.totalDeviceUsers?.iOS || 0, color: "bg-gray-600" },
  ];

  const maxValue = Math.max(...userStats.map(s => s.value), 1);

  return (
    <div className="bg-white px-4 py-4 border border-gray-100 shadow-md rounded-lg">
      {/* Header Area */}
      <div className="flex items-center justify-between">
        <h3 className="font-medium font-base">{t("dashboard.appUsers")}</h3>
        <CountrySelector />
      </div>
      <div className="mt-6"></div>

      {loading ? (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <div className="space-y-4">
          {userStats.map((stat, index) => (
            <div key={index} className="flex items-center">
              <div className="w-32 text-xs font-semibold text-gray-600">{stat.label}</div>
              <div className="flex-1 bg-gray-100 rounded h-6">
                <div
                  className={`${stat.color} h-6 rounded flex items-center justify-end pr-2 text-xs font-medium text-white transition-all duration-300`}
                  style={{ width: `${Math.max((stat.value / maxValue) * 100, stat.value > 0 ? 15 : 0)}%` }}
                >
                  {stat.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
